export const safeTColors = {
  primary: '#40c057',
  neutral: '#868e96',
  goal: '#fa5252',
  success: '#51cf66',
  warning: '#ffd43b',
  danger: '#ff6b6b',
  poamNoPoam: '#ff6b6b',
  poamOpenNotDev: '#ffd43b',
  poamDevNotMon: '#ff922b',
  poamMonNotShared: '#74c0fc',
  poamShared: '#51cf66',
} as const;
